/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientOverviewViewModel } from './PatientOverviewViewModel'; 

export function getPatientOverviewOptions(stayId: string, onSuccess?: (result: PatientOverviewViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-overview', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/ui/getpatientoverview/getpatientoverview/' + stayId;
			const resp = await axios.get<PatientOverviewViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}